import { AppDispatch } from '../../reducer';
import { MAPPED_ALERTS } from './mappedAlerts';
import { IAlert, TAlertTypes } from './types/alert.types';

const AlertTypes = {
  primary: 'primary',
  secondary: 'secondary',
  warning: 'warning',
  info: 'info',
  danger: 'danger',
  error: 'error',
  success: 'success',
  ['eemovel-success']: 'eemovel-success',
  ['eemovel-error']: 'eemovel-error',
  ['eemovel-warning']: 'eemovel-warning',
  ['eemovel-info']: 'eemovel-info',
};

export const ADD_ALERT = 'ADD_ALERT';
const addAlert = (alert: IAlert) => ({
  type: ADD_ALERT,
  payload: alert,
});

export const REMOVE_ALERT = 'REMOVE_ALERT';
const removeAlert = (alertId: string) => ({
  type: REMOVE_ALERT,
  payload: alertId,
});

const verifyType = (type: TAlertTypes) => {
  if (Object.keys(AlertTypes).includes(type)) {
    return type;
  }
  return 'secondary';
};

export const AddAlert = (
  t: TAlertTypes,
  m = 'Insira uma mensagem',
  h = 5000
) => {
  const alert = {
    type: verifyType(t),
    mensage: m,
    time: h,
    id:
      m === MAPPED_ALERTS.login.credentialsError
        ? 'CredentialsError'
        : Math.floor(Math.random() * 65536),
  };

  return (dispatch: AppDispatch) => {
    dispatch(addAlert(alert));
  };
};

export const RemoveAlert = (alertId: string) => {
  return (dispatch: AppDispatch) => {
    dispatch(removeAlert(alertId));
  };
};
